<div class="duplicate-ticket-modal">
  <div class="modal-header">
    <h4 class="modal-title">Mark Tickets as Duplicates</h4>
    <button class="close-btn" (click)="cancel()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="section">
      <h5>Select Original Ticket</h5>
      <p class="section-description">Choose which ticket should be considered the original (this ticket will remain open)</p>
      
      <div class="ticket-list">
        <div class="ticket-item" *ngFor="let ticket of selectedTickets">
          <label class="radio-label">
            <input type="radio" 
                   name="originalTicket" 
                   [value]="ticket.id"
                   [checked]="isOriginalTicket(ticket.id)"
                   (change)="onOriginalTicketChange(ticket)">
            <span class="radio-custom"></span>
            <div class="ticket-info">
              <div class="ticket-title">{{ getTicketDisplayName(ticket) }}</div>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div class="section" *ngIf="canShowDuplicateSection()">
      <h5>Select Duplicate Tickets</h5>
      <p class="section-description">Choose which tickets should be marked as duplicates of the original</p>
      
      <div class="ticket-list">
        <div class="ticket-item" *ngFor="let ticket of selectedTickets">
          <label class="checkbox-label" *ngIf="ticket.id !== originalTicket?.id">
            <input type="checkbox" 
                   [checked]="isDuplicateTicket(ticket.id)"
                   (change)="onDuplicateTicketChange(ticket, $event)">
            <span class="checkbox-custom"></span>
            <div class="ticket-info">
              <div class="ticket-title">{{ getTicketDisplayName(ticket) }}</div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button class="btn btn-primary" 
            (click)="markAsDuplicates()"
            [disabled]="!canMarkAsDuplicates()">
      Mark as Duplicates
    </button>
  </div>
</div> 